import React from 'react';
import './TaskPricePreview.css';

export const TaskPricePreview = ({ quote, className = '' }) => {
  const classes = `TaskPricePreview-container ${className}`.trim();

  if (!quote || quote.status === 'idle') {
    return (
      <div className={`${classes} is-idle`}>
        <span>💳 预扣积分：完善必填内容后计算</span>
      </div>
    );
  }
  if (quote.status === 'loading') {
    return (
      <div className={`${classes} is-loading`}>
        <span className="TaskPricePreview-spinner" />
        <span>正在计算预扣积分…</span>
      </div>
    );
  }
  if (quote.status === 'error') {
    return (
      <div className={`${classes} is-error`} title={quote.error || ''}>
        <span>⚠ 预扣积分暂不可用</span>
      </div>
    );
  }

  return (
    <div className={`${classes} is-success`}>
      <span>💳 预计预扣 <strong>{quote.points}</strong> 积分</span>
      <small>
        {quote.billingMode === 'deposit_adjust'
          ? '完成后按实际用量多退少补'
          : '以提交时的最终报价为准'}
      </small>
    </div>
  );
};

